import React, { FC } from 'react';
import { Flex, SkeletonCircle } from '@chakra-ui/react';

import SunshineCard from 'components/_core/SunshineCard';

interface ListSkeletonProps {
  count?: number;
}
const ListSkeleton: FC<ListSkeletonProps> = ({ count = 5 }) => {
  return (
    <SunshineCard.Group>
      {Array.from({ length: count }, (_, index) => (
        <SunshineCard key={index} opacity={1 - index * 0.2}>
          <SunshineCard.Content
            alignItems="center"
            flexDirection="row"
            justifyContent="space-between"
            padding={0}
          >
            <Flex direction="column" gap="space-6" w="400px">
              <SkeletonCircle
                borderRadius="radius-8"
                endColor="grey.400"
                h={19}
                startColor="grey.200"
                w={140}
              />
              <SkeletonCircle
                borderRadius="radius-8"
                endColor="grey.400"
                h={19}
                startColor="grey.200"
                w={300}
              />
            </Flex>
            <SkeletonCircle
              borderRadius="full"
              endColor="grey.400"
              startColor="grey.200"
              w={120}
            />
          </SunshineCard.Content>
        </SunshineCard>
      ))}
    </SunshineCard.Group>
  );
};

export default ListSkeleton;
